


import { RevolvaService } from './revolva.service';
import * as THREE from "three";
import * as actions from "@/service/revolva.action";
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';


export function loadGround(service: RevolvaService) {
    const { scene } = service
    const loader = new THREE.TextureLoader();
    const groundTexture = loader.load('../../textures/ground.jpg');
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(1, 1);
    groundTexture.anisotropy = 16;
    groundTexture.encoding = THREE.sRGBEncoding;

    const groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });

    const mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(1.5, 1.5), groundMaterial);
    mesh.position.y = - 0;
    mesh.rotation.x = - Math.PI / 2;
    mesh.receiveShadow = true;
    scene.add(mesh);
}

export function changDial(service: RevolvaService, color: string) {
    const { scene, pieces, piecesInScene } = service
    scene.remove(piecesInScene['piece2']);
    scene.remove(piecesInScene['piece4']);
    scene.remove(piecesInScene['piece5']);
    if (color === 'black') {
        piecesInScene['piece2'] = pieces[23];
        piecesInScene['piece4'] = pieces[24];
        piecesInScene['piece5'] = pieces[25];
    }
    if (color === 'blue') {
        piecesInScene['piece2'] = pieces[34];
        piecesInScene['piece4'] = pieces[24];
        piecesInScene['piece5'] = pieces[25];
    }
    if (color === 'grey') {
        piecesInScene['piece2'] = pieces[31];
        piecesInScene['piece4'] = pieces[32];
        piecesInScene['piece5'] = pieces[33];
    }

    scene.add(piecesInScene['piece2']);
    scene.add(piecesInScene['piece4']);
    scene.add(piecesInScene['piece5']);
}


export function seeInside(service: RevolvaService) {
    const { scene, finishedLoading3D, piecesInScene, seeInside } = service
    if (finishedLoading3D) {
        if (seeInside) {

            let index = -1;
            piecesInScene["piece1"].children.find(function (item, i) {
                if (item.name === "Circle005") {
                    index = i;
                    return i;
                }
            });
            piecesInScene["piece1"].children[index].visible = false;
            piecesInScene["piece1"].children.find(function (item, i) {
                if (item.name === "Circle010") {
                    index = i;
                    return i;
                }
            });
            piecesInScene["piece1"].children[index].visible = false;

        } else {
            let index = -1;
            piecesInScene["piece1"].children.find(function (item, i) {
                if (item.name === "Circle005") {
                    index = i;
                    return i;
                }
            });
            piecesInScene["piece1"].children[index].visible = true;
            piecesInScene["piece1"].children.find(function (item, i) {
                if (item.name === "Circle010") {
                    index = i;
                    return i;
                }
            });
            piecesInScene["piece1"].children[index].visible = true;
        }
        actions.renderModel(service);
    }
}


export function watchAnimation(service: RevolvaService) {
    const { piecesInScene, scene } = service
    const curdate = new Date();

    service.specialPieces[1].rotation.y =
        (-(((curdate.getSeconds() / 60 + curdate.getMinutes()) / 60) * 360) *
            Math.PI) /
        180;


    service.specialPieces[2].rotation.y =
        (-(((curdate.getHours() + curdate.getMinutes() / 60) / 12) * 360) *
            Math.PI) /
        180;



    service.specialPieces[3].rotation.y =
        (-(
            ((curdate.getSeconds() + curdate.getMilliseconds() / 1000) / 60) *
            360
        ) *
            Math.PI) /
        180;

}


export function changePosition(service: RevolvaService, piece: string, name: string, newPosition: number) {
    const { piecesInScene } = service
    let index = -1;

    piecesInScene[piece].children.find(function (item, i) {
        if (item.name === name) {
            index = i;
            return i;
        }
    });

    piecesInScene[piece].children[index].position.z = newPosition;

    if (service.sliderValue > 0 && name.includes("Plane"))
        piecesInScene[piece].children[index].castShadow = true;
    else if (service.sliderValue === 0 && name.includes("Plane"))
        piecesInScene[piece].children[index].castShadow = false;

}

export function changePositionPiece2(service: RevolvaService, piece: string, name: string, newPosition: number) {
    const { piecesInScene } = service
    let index = -1;

    piecesInScene[piece].children[0].children.find(function (item, i) {
        if (item.name === name) {
            index = i;
            return i;
        }
    });

    piecesInScene[piece].children[0].children[index].position.z = newPosition;

}

export function getIndex(service: RevolvaService, piece: string, name: string) {
    const { piecesInScene } = service
    let index = -1;

    piecesInScene[piece].children.find(function (item, i) {
        if (item.name === name) {
            index = i;
            return i;
        }
    });

    return index;
}



export function explodeMesh(service: RevolvaService) {
    const { piecesInScene } = service
    //let index = -1;





    //changePosition(service, "piece1", "Circle005", 0.027247492223978043);


    changePosition(service, "piece1", "Circle009", 0.09447889029979706 + service.sliderValue + (0.2 * service.sliderValue));



    changePosition(service, "piece1", "Circle001", 0.04477311670780182 + service.sliderValue + (0.18 * service.sliderValue));


    changePosition(service, "piece1", "Circle002", 0.024000070989131927 + service.sliderValue + (0.13 * service.sliderValue));



    changePosition(service, "piece1", "Circle011", 0.003676576539874077 + service.sliderValue + (0.16 * service.sliderValue));



    changePosition(service, "piece1", "Plane", 0 + service.sliderValue - (0.14 * service.sliderValue));


    changePosition(service, "piece1", "Plane001", 0 + service.sliderValue - (0.12 * service.sliderValue));


    changePosition(service, "piece1", "Plane002", 0 + service.sliderValue - (0.10 * service.sliderValue));


    changePosition(service, "piece1", "Plane003", 0 + service.sliderValue - (0.08 * service.sliderValue));


    changePosition(service, "piece1", "Plane004", 0 + service.sliderValue - (0.06 * service.sliderValue));


    changePosition(service, "piece1", "Plane005", 0 + service.sliderValue - (0.04 * service.sliderValue));


    changePosition(service, "piece1", "Plane006", 0 + service.sliderValue - (0.18 * service.sliderValue));


    changePosition(service, "piece1", "Plane007", 0 + service.sliderValue - (0.20 * service.sliderValue));


    changePosition(service, "piece1", "Plane008", 0 + service.sliderValue - (0.22 * service.sliderValue));


    changePosition(service, "piece1", "Plane009", 0 + service.sliderValue - (0.24 * service.sliderValue));


    changePosition(service, "piece1", "Plane010", 0 + service.sliderValue - (0.26 * service.sliderValue));



    changePosition(service, "piece1", "Plane011", 0 + service.sliderValue - (0.28 * service.sliderValue));


    changePosition(service, "piece1", "Plane012", 0 + service.sliderValue - (0.30 * service.sliderValue));


    changePosition(service, "piece1", "Plane013", 0 + service.sliderValue - (0.31 * service.sliderValue));


    changePosition(service, "piece1", "Plane014", 0 + service.sliderValue - (0.32 * service.sliderValue));


    changePosition(service, "piece1", "Plane015", 0 + service.sliderValue - (0.33 * service.sliderValue));


    changePosition(service, "piece1", "Plane016", 0 + service.sliderValue - (0.34 * service.sliderValue));




    changePosition(service, "piece1", "Plane017", 0 + service.sliderValue - (0.35 * service.sliderValue));



    changePosition(service, "piece1", "Plane018", 0 + service.sliderValue - (0.36 * service.sliderValue));


    changePosition(service, "piece1", "Plane019", 0 + service.sliderValue - (0.38 * service.sliderValue));


    changePosition(service, "piece1", "Plane020", 0 + service.sliderValue - (0.40 * service.sliderValue));


    changePosition(service, "piece1", "Plane021", 0 + service.sliderValue - (0.42 * service.sliderValue));


    changePosition(service, "piece1", "Plane022", 0 + service.sliderValue - (0.44 * service.sliderValue));


    changePosition(service, "piece1", "Plane023", 0 + service.sliderValue - (0.46 * service.sliderValue));


    changePosition(service, "piece1", "Plane024", 0 + service.sliderValue - (0.48 * service.sliderValue));


    changePosition(service, "piece1", "Plane025", 0 + service.sliderValue - (0.48 * service.sliderValue));


    changePosition(service, "piece1", "Plane026", 0 + service.sliderValue - (0.50 * service.sliderValue));


    // back of the mechanic.


    // changePosition(service, "piece1", "Circle010", -0.1755179762840271 - service.sliderValue);

    changePositionPiece2(service, "piece2", "watchmechanism001", -0.1037728562951088 + service.sliderValue + (0.50 * service.sliderValue));


    changePositionPiece2(service, "piece2", "watchmechanism002", -0.2990608513355255 + service.sliderValue + (0.45 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism003", -0.1037728562951088 + service.sliderValue + (0.40 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism004", -0.17171838879585266 + service.sliderValue + (0.35 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism025", -0.18194976449012756 + service.sliderValue + (0.30 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism028", -0.05946115404367447 + service.sliderValue + (0.25 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism043", -0.04594460874795914 + service.sliderValue + (0.20 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism049", -0.1990133821964264 + service.sliderValue + (0.15 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism050", -0.5740567445755005 + service.sliderValue + (0.10 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism070", -0.5453105568885803 + service.sliderValue + (0 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism079", -0.4320339262485504 + service.sliderValue - (0.5 * service.sliderValue));

    changePositionPiece2(service, "piece2", "watchmechanism080", -0.43178972601890564 + service.sliderValue - (0.10 * service.sliderValue));

    changePositionPiece2(service, "piece2", "Plane010", 0.06476589292287827 + service.sliderValue - (0.15 * service.sliderValue));


    changePosition(service, "piece1", "Circle010", -0.1755179762840271 - service.sliderValue - (0.15 * service.sliderValue));

    changePosition(service, "piece1", "Circle012", -0.5521771907806396 - service.sliderValue - (0.15 * service.sliderValue));



    // let index = -1;
    // piecesInScene["piece1"].children.find(function (item, i) {
    //     if (item.name === "Circle012") {
    //         index = i;
    //         return i;
    //     }
    // });
    // console.log(piecesInScene["piece1"].children[index].position.z);

    // piecesInScene["piece1"].children[index].position.z = 0 + service.sliderValue - (0.52 * service.sliderValue);

    //changePosition(service, "Sphere", 0 + service.sliderValue - (0.52 * service.sliderValue));




}


export function playSound(service: RevolvaService) {
    service.playSound = !service.playSound;
    if (service.playSound) service.sound.play();
    else service.sound.stop();
}

// export function updateScreenPosition(service: RevolvaService, id: number) {
//     const vector = new THREE.Vector3(-1.5, -0.3, 0.5);
//     const canvas = service.renderer.domElement;

//     vector.project(service.camera);

//     vector.x = Math.round((0.5 + vector.x / 2) * (canvas.width / window.devicePixelRatio));
//     vector.y = Math.round((0.5 - vector.y / 2) * (canvas.height / window.devicePixelRatio));

//     service.annotationList[id].style.top = `${vector.y}px`;
//     service.annotationList[id].style.left = `${vector.x}px`;
//      //annotation.style.opacity = spriteBehindObject ? 0.25 : 1;
//  }


export function updateAnnotationText(service: RevolvaService, title: string, text: string) {
    const annotationTitle = document.querySelector(".annotationTitle");
    annotationTitle.innerHTML = title;
    const annotationText = document.querySelector(".annotationText");
    annotationText.innerHTML = text;
}

export function removeMarkerInfo(service: RevolvaService) {

    service.piecesInScene['piece1'].children[getIndex(service, "piece1", "Circle014")].remove(service.spriteInfo[1]);
    service.piecesInScene['piece1'].children[getIndex(service, "piece1", "Cube006")].remove(service.spriteInfo[2]);
    service.piecesInScene['piece1'].children[getIndex(service, "piece1", "Circle005")].remove(service.spriteInfo[3]);

    // @ts-ignore
    document.querySelector(".revolvaAnnotation").style.display = "none"
}

export function showMarkerInfo(service: RevolvaService) {
    service.piecesInScene['piece1'].children[getIndex(service, "piece1", "Circle014")].add(service.spriteInfo[1]);
    service.piecesInScene['piece1'].children[getIndex(service, "piece1", "Cube006")].add(service.spriteInfo[2]);
    service.piecesInScene['piece1'].children[getIndex(service, "piece1", "Circle005")].add(service.spriteInfo[3]);

    // @ts-ignore
    document.querySelector(".revolvaAnnotation").style.display = "block"
}

export function createAnnotationDom(service: RevolvaService) {

    const loader = new THREE.TextureLoader();
    loader.crossOrigin = "";
    const map = loader.load("info.png");
    map.encoding = THREE.sRGBEncoding


    const spriteMaterialInfo = new THREE.SpriteMaterial({
        map,
        opacity: 0.9,
        transparent: true,
        depthTest: false
    });

    // for sound
    let position = new THREE.Vector3(-1.5, -0.3, 0.5);

    service.spriteInfo[1] = new THREE.Sprite(spriteMaterialInfo);
    service.spriteInfo[1].position.copy(position);
    service.spriteInfo[1].scale.set(0.2, 0.2, 0.2);

    // for strap
    position = new THREE.Vector3(0.9, 0.3, 0);
    service.spriteInfo[2] = new THREE.Sprite(spriteMaterialInfo);
    service.spriteInfo[2].position.copy(position);
    service.spriteInfo[2].scale.set(0.2, 0.2, 0.2);

    // for dial
    position = new THREE.Vector3(0.1, 0.1, 0);
    service.spriteInfo[3] = new THREE.Sprite(spriteMaterialInfo);
    service.spriteInfo[3].position.copy(position);
    service.spriteInfo[3].scale.set(0.2, 0.2, 0.2);

}








// export function updateAnnotationOpacity(service: RevolvaService) {
//     const meshDistance = service.camera.position.distanceTo(mesh.position);
//     const spriteDistance = service.camera.position.distanceTo(sprite.position);
//     spriteBehindObject = spriteDistance > meshDistance;
//     sprite.material.opacity = spriteBehindObject ? 0.25 : 1;

//     // Do you want a number that changes size according to its position?
//     // Comment out the following line and the `::before` pseudo-element.
//     sprite.material.opacity = 0;
// }



